import { useState, useEffect } from "react";

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export default function ClientsData() {
  const originalClients = [
   { src: "../assets/img/logo/1.jpg", alt: "Web Development Services", delay: 200 },
  { src: "../assets/img/logo/2.jpg", alt: "Ecommerce Website Design", delay: 300 },
  { src: "../assets/img/logo/3.jpg", alt: "Freelance Web Developer", delay: 400 },
  { src: "../assets/img/logo/4.jpg", alt: "Responsive Web Design", delay: 500 },
  { src: "../assets/img/logo/5.jpg", alt: "Mobile App Development", delay: 600 },
  { src: "../assets/img/logo/6.jpg", alt: "Digital Marketing Agency", delay: 700 },
  { src: "../assets/img/logo/7.jpg", alt: "WordPress Development", delay: 800 },
  { src: "../assets/img/logo/8.jpg", alt: "SEO Services India", delay: 900 },
  { src: "../assets/img/logo/9.jpg", alt: "UI UX Design Agency", delay: 1000 },
  { src: "../assets/img/logo/10.jpg", alt: "Custom Web Application", delay: 200 },
  { src: "../assets/img/logo/11.jpg", alt: "Software Development Company", delay: 300 },
  { src: "../assets/img/logo/12.jpg", alt: "Website Maintenance Services", delay: 400 },
  { src: "../assets/img/logo/13.jpg", alt: "PHP Developer India", delay: 500 },
  { src: "../assets/img/logo/14.jpg", alt: "Landing Page Design", delay: 600 },
  { src: "../assets/img/logo/15.jpg", alt: "React JS Developer", delay: 700 },
  { src: "../assets/img/logo/16.jpg", alt: "Frontend Development", delay: 800 },
  { src: "../assets/img/logo/17.jpg", alt: "Backend Development", delay: 900 },
  { src: "../assets/img/logo/18.jpg", alt: "Full Stack Developer India", delay: 1000 },
  { src: "../assets/img/logo/19.jpg", alt: "Graphic Design Services", delay: 200 },
  { src: "../assets/img/logo/20.jpg", alt: "Website Design Company", delay: 300 },
  { src: "../assets/img/logo/21.jpg", alt: "UX Audit and Testing", delay: 400 },
  { src: "../assets/img/logo/22.jpg", alt: "Shopify Developer India", delay: 500 },
  { src: "../assets/img/logo/23.jpg", alt: "Website Redesign Services", delay: 600 },
  { src: "../assets/img/logo/24.jpg", alt: "JavaScript Development Company", delay: 700 },
  { src: "../assets/img/logo/25.jpg", alt: "Custom CMS Solutions", delay: 800 },
  { src: "../assets/img/logo/26.jpg", alt: "Laravel Developer India", delay: 900 },
  { src: "../assets/img/logo/27.jpg", alt: "ASP.NET Development", delay: 1000 },
  { src: "../assets/img/logo/28.jpg", alt: "Web Portal Development", delay: 200 },
  { src: "../assets/img/logo/29.jpg", alt: "Angular Developer India", delay: 300 },
  { src: "../assets/img/logo/30.jpg", alt: "WordPress Theme Customization", delay: 400 },
  { src: "../assets/img/logo/31.jpg", alt: "Graphic and Logo Design", delay: 500 },
  { src: "../assets/img/logo/32.jpg", alt: "UX/UI Consultation", delay: 600 },
  { src: "../assets/img/logo/33.jpg", alt: "HTML CSS Development", delay: 700 },
  { src: "../assets/img/logo/34.jpg", alt: "Node JS Developer India", delay: 800 },
  { src: "../assets/img/logo/35.jpg", alt: "Mobile First Web Design", delay: 900 },
  { src: "../assets/img/logo/36.jpg", alt: "Online Branding Agency", delay: 1000 },
  { src: "../assets/img/logo/37.jpg", alt: "Blog Website Design", delay: 200 },
  { src: "../assets/img/logo/38.jpg", alt: "Web Hosting and Support", delay: 300 },
  { src: "../assets/img/logo/39.jpg", alt: "Website Optimization Expert", delay: 400 },
  { src: "../assets/img/logo/40.jpg", alt: "Custom Web Portals", delay: 500 },
  { src: "../assets/img/logo/41.jpg", alt: "Java Developer India", delay: 600 },
  { src: "../assets/img/logo/42.jpg", alt: "Online Store Development", delay: 700 },
  { src: "../assets/img/logo/43.jpg", alt: "Cloud Hosting Setup", delay: 800 },
  { src: "../assets/img/logo/44.jpg", alt: "API Integration Services", delay: 900 },
  { src: "../assets/img/logo/45.jpg", alt: "Corporate Website Design", delay: 1000 },
  { src: "../assets/img/logo/46.jpg", alt: "Branding and Identity Design", delay: 200 },
  { src: "../assets/img/logo/47.jpg", alt: "Drupal Development Company", delay: 300 },
  { src: "../assets/img/logo/48.jpg", alt: "Real Estate Website Design", delay: 400 },
  { src: "../assets/img/logo/49.jpg", alt: "Fashion Website Designer", delay: 500 },
  { src: "../assets/img/logo/50.jpg", alt: "Healthcare Website Developer", delay: 600 },
  { src: "../assets/img/logo/51.jpg", alt: "Education Website Developer", delay: 700 },
  { src: "../assets/img/logo/52.jpg", alt: "Hotel Website Design", delay: 800 },
  { src: "../assets/img/logo/53.jpg", alt: "Law Firm Website Developer", delay: 900 },
  { src: "../assets/img/logo/54.jpg", alt: "NGO Website Designer India", delay: 1000 },
  { src: "../assets/img/logo/55.jpg", alt: "Bakery Website Design", delay: 200 },
  { src: "../assets/img/logo/56.jpg", alt: "Portfolio Website Design", delay: 300 },
  { src: "../assets/img/logo/57.jpg", alt: "WordPress Plugin Developer", delay: 400 },
  { src: "../assets/img/logo/58.jpg", alt: "Web App UI Developer", delay: 500 },
  { src: "../assets/img/logo/59.jpg", alt: "CRM Development Company", delay: 600 },
  { src: "../assets/img/logo/60.jpg", alt: "ERP Software Developer", delay: 700 },
  { src: "../assets/img/logo/61.jpg", alt: "Hotel Booking Website", delay: 800 },
  { src: "../assets/img/logo/62.jpg", alt: "Directory Website Developer", delay: 900 },
  { src: "../assets/img/logo/63.jpg", alt: "Fitness Website Design", delay: 1000 },
  { src: "../assets/img/logo/64.jpg", alt: "Car Rental Website", delay: 200 },
  { src: "../assets/img/logo/65.jpg", alt: "Event Website Developer", delay: 300 },
  { src: "../assets/img/logo/66.jpg", alt: "Beauty Salon Website", delay: 400 },
  { src: "../assets/img/logo/67.jpg", alt: "Cleaning Service Website", delay: 500 },
  { src: "../assets/img/logo/68.jpg", alt: "Job Portal Developer", delay: 600 },
  { src: "../assets/img/logo/69.jpg", alt: "Classified Website Developer", delay: 700 },
  { src: "../assets/img/logo/70.jpg", alt: "Matrimonial Website Design", delay: 800 },
  { src: "../assets/img/logo/71.jpg", alt: "Payment Gateway Integration", delay: 900 },
  { src: "../assets/img/logo/72.jpg", alt: "Email Marketing Services", delay: 1000 },
  { src: "../assets/img/logo/73.jpg", alt: "PPC Management Services", delay: 200 },
  { src: "../assets/img/logo/74.jpg", alt: "Social Media Manager", delay: 300 },
  { src: "../assets/img/logo/75.jpg", alt: "YouTube Channel Website", delay: 400 },
  { src: "../assets/img/logo/76.jpg", alt: "Blog Customization Services", delay: 500 },
  { src: "../assets/img/logo/77.jpg", alt: "Photography Website Design", delay: 600 },
  { src: "../assets/img/logo/78.jpg", alt: "Pet Website Developer", delay: 700 },
  { src: "../assets/img/logo/79.jpg", alt: "Interior Designer Website", delay: 800 },
  { src: "../assets/img/logo/80.jpg", alt: "Fashion Blog Website", delay: 900 }
  ];

  const [shuffledClients, setShuffledClients] = useState(() =>
    shuffleArray(originalClients)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setShuffledClients(shuffleArray(originalClients));
    }, 5000); // shuffle every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="Clients" className="clients">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Valued Partners</h2>
          <p>Proudly Associated With</p>
        </header>

        <ul className="clients-logo-list animated-list">
          {shuffledClients.map((client, index) => (
             <li
    key={index}
    className="client-logo"
    style={{ animationDelay: `${index * 0.05}s` }} // 50ms stagger
  >
    <img
      src={client.src}
      className="img-fluid"
      alt={client.alt}
      loading="lazy"
    />
  </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
